import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { CUISINE_TYPES_QUERY } from '../graphql/queries'
import { COMMON_FETCH_CUISINE_TYPES } from '../redux/action-types'
import { cleanupCommonFetchCuisineTypes } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useCuisineTypesQuery = () => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchCuisineTypes)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.cuisineTypes,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        CUISINE_TYPES_QUERY,
        {},
        dispatch,
        COMMON_FETCH_CUISINE_TYPES,
      ),
    [dispatch],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useCuisineTypesQuery
